import React from 'react'
import '../estilos/Body.css'
import {} from 'react-router-dom'
import body from '../img/body.png'

function Inicio () {
  return (
    <div>
    <div className='inicio' style={{ backgroundImage: `url(${body})` }}>
        <div className='contenedor' >
            <p className='texto'>Venta de equipos, instalación, mantenimiento y refacciones</p>
        </div>
    </div>
    <div className='contactos'>
       <p className='correo'>Contacto: enrique.cordova@uniclima.mx</p>
       <p className='numero'>(871) 717-82-50</p>
       <p className='numero-'>717-82-22
        &nbsp;-&nbsp;  717-64-50 </p>
    </div>
    </div>
  )
}

export default Inicio
